"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _bubblenav_styles = _interopRequireDefault(require("./bubblenav_styles"));

var _bubblenav_definition = _interopRequireDefault(require("./bubblenav_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/* ========== ~~~~~~~~~~ EXPORT : NAV : BUBBLE ~~~~~~~~~~ ========== */


var BubbleNav = (0, _reactJss.default)(_bubblenav_styles.default)(function (props) {
  return _react.default.createElement(_index.NavLinks, _extends({}, props, {
    klass: props.classes.bubblenav
  }));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(BubbleNav, _bubblenav_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = BubbleNav;
exports.default = _default;